import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { useI18n } from "../context/I18nContext";

export default function NotFoundPage() {
  const { t } = useI18n();
  return (
    <section className="py-32 text-center bg-white" data-testid="not-found-page">
      <span className="text-xs tracking-[0.2em] uppercase text-[#1a5193] font-chivo font-bold">
        {t("not_found.eyebrow")}
      </span>
      <h1 className="font-chivo font-black text-5xl text-[#082c50] mt-4">
        {t("not_found.h1")}
      </h1>
      <p className="text-gray-600 mt-3 max-w-md mx-auto">{t("not_found.desc")}</p>
      <Button
        asChild
        className="mt-8 bg-[#082c50] hover:bg-[#082c50] text-white rounded-xl font-chivo font-bold uppercase text-xs"
      >
        <Link to="/">{t("not_found.back_home")}</Link>
      </Button>
    </section>
  );
}
